export default __webpack_public_path__ + "static/waterdrops-16ed2ebd3e08dc6def5127a212c72288.png";